// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@imgs/register/new-theme/head-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@imgs/register/red-theme/logo-big.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@imgs/register/new-theme/bottom-body-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@imgs/activity/check.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes skin10_rotate__HyQR\\+ {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.skin10_skin5__9Uzq0 {
  height: 100%;
  background-color: #f5f6f9;
  line-height: normal;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs {
  padding: 5.333333vw 4.266667vw 2.666667vw;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 58.666667vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk {
  font-size: 5.333333vw;
  font-weight: 600;
  line-height: 5.333333vw;
  display: flex;
  align-items: center;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk .skin10_logo__688xN {
  margin-right: 2.666667vw;
  width: 11.2vw;
  height: 11.2vw;
  background-size: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk .skin10_logoBoxRight__q\\+4Vb {
  display: flex;
  flex-direction: column;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk .skin10_logoBoxRight__q\\+4Vb .skin10_logoText__TMWXq {
  width: 21.333333vw;
  height: 5.6vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk .skin10_logoBoxRight__q\\+4Vb .skin10_youqianLogoText__D35yW {
  height: 5.6vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk .skin10_logoBoxRight__q\\+4Vb .skin10_youqianLogoText__D35yW {
  width: 16vw;
  height: 5.6vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk .skin10_logoBoxRight__q\\+4Vb .skin10_logoText2__RS13Z {
  margin-top: 1.066667vw;
  width: 20.266667vw;
  height: 2.666667vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_logoBox__KZACk .skin10_logoBoxRight__q\\+4Vb .skin10_logoText3__pGpiw {
  margin-top: 1px;
  font-size: 3.2vw;
  color: #fff;
  font-weight: 600;
  transform: scale(0.86) translateX(-2.666667vw);
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk {
  margin-top: 6.666667vw;
  width: 91.466667vw;
  background: linear-gradient(180deg, #FBE5D7 0%, #FFFFFF 27.54%);
  border-radius: 2.133333vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperHead__ed0ZM {
  width: 100%;
  height: 13.333333vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 7.733333vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW {
  margin-top: 3.2vw;
  padding: 6.4vw 3.2vw 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_inputWrapperContainetTips__DE4w5 {
  font-size: 3.733333vw;
  margin-bottom: 2.133333vw;
  color: #262626;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_inputBox__5Z9CE {
  position: relative;
  display: flex;
  align-items: center;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_inputBox__5Z9CE .skin10_inputBoxSymbol__2IAP- {
  font-size: 10.133333vw;
  line-height: 13.866667vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_inputBox__5Z9CE .adm-input-element {
  font-size: 8.8vw;
  font-weight: 600;
  line-height: 8vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_inputBox__5Z9CE .adm-input-element::placeholder {
  font-size: 5.866667vw;
  line-height: 8vw;
  font-weight: normal;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_inputBox__5Z9CE .skin10_text__WOR9\\+ {
  position: absolute;
  right: 0;
  bottom: 3.733333vw;
  display: flex;
  align-items: center;
  color: #AD6800;
  font-size: 3.2vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_inputBox__5Z9CE .skin10_text__WOR9\\+ .skin10_clear__BVvQu {
  padding-left: 2.4vw;
  color: #8C8C8C;
  font-size: 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_moneyOptions__XmFfg {
  margin-top: 2.666667vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_moneyOptions__XmFfg .skin10_moneyItem__lOF7o {
  flex: 1 1;
  height: 8.533333vw;
  padding: 1.066667vw 2.133333vw;
  border-radius: 1.6vw;
  box-sizing: border-box;
  font-size: 3.733333vw;
  background-color: #F3F4F6;
  color: #8C8C8C;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  font-weight: 600;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_moneyOptions__XmFfg .skin10_moneyItem__lOF7o:nth-child(2n+2) {
  margin: 0 2.133333vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_moneyOptions__XmFfg .skin10_moneyItem__lOF7o.skin10_moneyItemActive__LcGTZ {
  color: #ff2f2f;
  border: 1px solid #ff2f2f;
  background-color: rgba(255, 44, 62, 0.1);
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_line__nuhCT {
  margin: 4.266667vw 0;
  width: 100%;
  height: 1px;
  background-color: #EAEAEA;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_moneyRateTips__43dl9 {
  display: flex;
  align-items: center;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_moneyRateTips__43dl9 .skin10_moneyRateText1__uuhkT {
  padding: 0.8vw 2.133333vw;
  background-color: #DE9960;
  border-radius: 1.066667vw;
  color: #fff;
  font-size: 3.2vw;
  margin-right: 2.133333vw;
}
.skin10_skin5__9Uzq0 .skin10_header__Twdzs .skin10_inputWrapper__NzAPk .skin10_inputWrapperContainer__nZHyW .skin10_moneyRateTips__43dl9 .skin10_moneyRateText2__-VKvz {
  color: #262626;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv {
  width: 93.866667vw;
  margin: 2.933333vw auto 4.266667vw;
  padding-bottom: 8.533333vw;
  background: #fff;
  border-radius: 2.133333vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_title__JUXnq {
  width: 100%;
  height: 10.133333vw;
  background: linear-gradient(180deg, #FDF2E5 0%, #FBE4CE 100%);
  border-radius: 1.6vw 1.6vw 0px 0px;
  text-align: center;
  line-height: 10.133333vw;
  font-weight: 400;
  font-size: 3.2vw;
  color: #DE9960;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv h3 {
  font-weight: 600;
  font-size: 4.266667vw;
  color: #333;
  padding: 3.2vw 4.266667vw 0;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv h3 span {
  font-size: 3.2vw;
  color: #BB6C1D;
  font-weight: normal;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_loanTermList__dNIDa {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 4.266667vw;
  margin-top: 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_loanTermList__dNIDa .skin10_loanTermItem__0PbPo {
  width: 26.933333vw;
  height: 8vw;
  background-color: #f3f4f6;
  text-align: center;
  border-radius: 1.333333vw;
  box-sizing: border-box;
  font-weight: 600;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_loanTermList__dNIDa .skin10_loanTermItem__0PbPo p {
  font-size: 3.733333vw;
  color: #8C8C8C;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_loanTermList__dNIDa .skin10_loanTermItem__0PbPo p.skin10_samllText__hv5oj {
  font-size: 3.2vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_loanTermList__dNIDa .skin10_loanTermItem__0PbPo.skin10_active__bBjBM {
  background-color: #FF2C3E;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_loanTermList__dNIDa .skin10_loanTermItem__0PbPo.skin10_active__bBjBM p {
  font-size: 3.733333vw;
  color: #fff;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_loanTermList__dNIDa .skin10_loanTermItem__0PbPo.skin10_is360Channel__0YX-k {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC {
  margin-top: 5.333333vw;
  box-sizing: border-box;
  padding: 0 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC p {
  width: 100%;
  display: flex;
  justify-content: center;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC p span {
  display: inline-block;
  color: #c16818;
  height: 10.933333vw;
  line-height: 10.933333vw;
  padding: 0 4.266667vw;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_phoneBox__dtfqm {
  height: 12.266667vw;
  background: #f4f5f7;
  border-radius: 2.133333vw;
  display: flex;
  align-items: center;
  margin: 2.4vw auto 0;
  padding-left: 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_phoneBox__dtfqm .skin10_label__w6beC {
  width: 45.333333vw;
  text-align: center;
  font-size: 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_phoneBox__dtfqm .adm-input-element {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_phoneBox__dtfqm .adm-input-element::placeholder {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_getCms__PRUk3 {
  margin-top: 3.2vw;
  height: 12.266667vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(180deg, #ffcfa0 1%, #e19459);
  border-radius: 1.6vw;
  color: #FFFFFF;
  font-size: 4.266667vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_agreement__OXp1k {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_agreement__OXp1k .skin10_primary__W7y49 {
  color: #DE9960;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_agreement__OXp1k {
  margin-top: 5.333333vw;
  font-size: 3.2vw;
  color: #8C8C8C;
  line-height: 4.8vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_agreement__OXp1k.skin10_animation__YcbVn {
  position: relative;
  animation: skin10_shake__j\\+YV6 0.1s;
}
@keyframes skin10_shake__j\\+YV6 {
  0% {
    left: 2.133333vw;
  }
  50% {
    left: -2.133333vw;
  }
  100% {
    left: 0;
  }
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_agreement__OXp1k .skin10_checked__rVvLz {
  margin-right: 1.6vw;
  border: 1px solid #D9D9D9;
  border-radius: 100%;
  width: 4.8vw;
  height: 4.8vw;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_agreement__OXp1k .skin10_checked__rVvLz.skin10_active__bBjBM {
  position: relative;
  border: none;
  background: #DE9960;
}
.skin10_skin5__9Uzq0 .skin10_checkBox__9VZBv .skin10_bottomBody__eTLCC .skin10_agreement__OXp1k .skin10_checked__rVvLz.skin10_active__bBjBM::before {
  position: absolute;
  top: 1.6vw;
  left: 1.066667vw;
  width: 2.666667vw;
  height: 1.866667vw;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100%;
}
.skin10_skin5__9Uzq0 .skin10_tipBox__HulL\\+ {
  padding-bottom: 13.333333vw;
}
.skin10_skin5__9Uzq0 .skin10_tipBox__HulL\\+ .skin10_tip__kTfuF {
  font-size: 3.2vw;
  line-height: 5.333333vw;
  text-align: center;
  color: #8C8C8C;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: none;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos.skin10_showPopup__WYPn6 {
  display: block;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos .skin10_dialogMain__QQ22O {
  width: 85.333333vw;
  height: 48vw;
  border-radius: 2.133333vw;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 5.333333vw 0;
  box-sizing: border-box;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos .skin10_dialogMain__QQ22O .skin10_close__WBZn1 {
  width: 100%;
  font-size: 5.333333vw;
  text-align: right;
  margin-right: 5.333333vw;
  color: rgb(214, 217, 223);
  padding-right: 5.333333vw;
  box-sizing: border-box;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos .skin10_dialogMain__QQ22O .skin10_inputBox__5Z9CE {
  width: 76vw;
  height: 12.8vw;
  border: 1px solid #e19459;
  margin: 2.666667vw auto;
  padding-left: 5.333333vw;
  border-radius: 2.133333vw;
  display: flex;
  align-items: center;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos .skin10_dialogMain__QQ22O .skin10_inputBox__5Z9CE .skin10_code__iLStL {
  width: 40vw;
  text-align: center;
  color: #e19459;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos .skin10_dialogMain__QQ22O .skin10_inputBox__5Z9CE .adm-input-element {
  font-size: 4vw;
  line-height: 8vw;
}
.skin10_skin5__9Uzq0 .skin10_dialogOverlay__vVYos .skin10_dialogMain__QQ22O .skin10_limit__ArtDL {
  margin: 4.8vw auto;
  width: 75.466667vw;
  height: 11.733333vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(180deg, #ffcfa0 1%, #e19459);
  border-radius: 1.6vw;
  color: #FFFFFF;
  font-size: 4.266667vw;
}

.adm-auto-center .adm-auto-center-content {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/mixin.scss","webpack://./src/pages/register/components/skin10/skin10.module.scss","webpack://./src/styles/var.scss"],"names":[],"mappings":"AA4KA;EACE;IACE,uBAAA;EC3KF;ED8KA;IACE,yBAAA;EC5KF;AACF;AAJA;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;AAMF;AAJE;EACE,yCAAA;EACA,WAAA;EACA,4BAAA;EACA,iCAAA;EACA,yDAAA;AAMJ;AAJI;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAMN;AAJM;EACE,wBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yDAAA;AAMR;AAHM;EACE,aAAA;EACA,sBAAA;AAKR;AAJQ;EACE,kBAAA;EACA,aAAA;AAMV;AAJQ;EAEE,aAAA;AAKV;AAHQ;EACE,WAAA;EACA,aAAA;AAKV;AAHQ;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;AAKV;AAHQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,8CAAA;AAKV;AAAI;EACE,sBAAA;EACA,kBAAA;EACA,+DAAA;EACA,yBAAA;AAEN;AAAM;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AAER;AACM;EACE,iBAAA;EACA,+BAAA;AACR;AAAQ;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;AAEV;AAAQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAEV;AADU;EACE,sBAAA;EACA,wBAAA;AAGZ;AACY;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AACd;AAAc;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;AAEhB;AAGU;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADZ;AAGY;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AADd;AAKQ;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAHV;AAIU;EACE,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFZ;AAGY;EACE,oBAAA;AADd;AAGY;EACE,cAAA;EACA,yBAAA;EACA,wCAAA;AADd;AAKQ;EACE,oBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AAHV;AAKQ;EACE,aAAA;EACA,mBAAA;AAHV;AAIU;EACE,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;AAFZ;AAIU;EACE,cAAA;AAFZ;AASE;EACE,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;AAPJ;AAQI;EACE,WAAA;EACA,mBAAA;EACA,6DAAA;EACA,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AANN;AAQI;EACE,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,2BAAA;AANN;AAOM;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AALR;AAQI;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;AANN;AAOM;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AALR;AAMQ;EACE,qBAAA;EACA,cAAA;AAJV;AAKU;EACE,gBAAA;AAHZ;AAMQ;EACE,yBAAA;AAJV;AAKU;EACE,qBAAA;EACA,WAAA;AAHZ;AAMQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAJV;AASI;EACE,sBAAA;EACA,sBAAA;EACA,qBAAA;AAPN;AAQM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AANR;AAOQ;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,4BAAA;EACA,0BAAA;EACA,yDAAA;AALV;AAQM;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;AANR;AAOQ;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AALV;AAQU;EACE,qBAAA;EACA,gBAAA;AANZ;AAOY;EACE,qBAAA;EACA,gBAAA;AALd;AAUM;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8DAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AARR;AAUM;ED1CJ,aAAA;EAGE,uBAAA;EAIA,mBAAA;ECqCI,eAAA;AANR;AAQQ;EACE,cAAA;AANV;AACM;EAQE,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AANR;AAQQ;EACE,kBAAA;EACA,oCAAA;AANV;AASQ;EACE;IACE,gBAAA;EAPV;EAUQ;IACE,iBAAA;EARV;EAWQ;IACE,OAAA;EATV;AACF;AAYQ;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAVV;AAYU;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;AAVZ;AAYY;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,qBAAA;AAVd;AAkBE;EACE,2BAAA;AAhBJ;AAiBI;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cCjVY;ADkUlB;AAmBE;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AAjBJ;AAkBI;EACE,cAAA;AAhBN;AAkBI;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;AAhBN;AAiBM;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAfR;AAiBM;EACE,WAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAfR;AAgBQ;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AAdV;AAiBU;EACE,cAAA;EACA,gBAAA;AAfZ;AAmBM;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8DAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AAjBR;;AAyBI;EACE,6BAAA;AAtBN","sourcesContent":["@charset \"UTF-8\";\n\n// 圆圈\n@mixin circle($width) {\n  display: inline-block;\n  border-radius: 50%;\n  width: $width;\n  height: $width;\n}\n\n// 省略号样式\n@mixin ellipsis($lineNum: \"\") {\n  overflow: hidden;\n\n  @if $lineNum != \"\" {\n    /* stylelint-disable-next-line */\n    display: -webkit-box;\n    /* stylelint-disable-next-line */\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: $lineNum;\n  } @else {\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// css箭头\n@mixin arrow($direction, $width, $height, $color) {\n  display: inline-block;\n  width: 0;\n  height: 0;\n\n  @if $direction == \"top\" {\n    border-top: 0;\n    border-right: solid $width transparent;\n    border-bottom: solid $height $color;\n    border-left: solid $width transparent;\n  } @else if $direction == \"bottom\" {\n    border-top: solid $height $color;\n    border-right: solid $width transparent;\n    border-bottom: 0;\n    border-left: solid $width transparent;\n  } @else if $direction == \"left\" {\n    border-top: solid $height transparent;\n    border-right: solid $width $color;\n    border-bottom: solid $height transparent;\n    border-left: 0;\n  } @else if $direction == \"right\" {\n    border-top: solid $height transparent;\n    border-right: 0;\n    border-bottom: solid $height transparent;\n    border-left: solid $width $color;\n  }\n}\n\n// 上下左右居中，为解决被外部数据覆盖的问题，强制使用!important\n@mixin setXYMiddle($width, $height) {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  margin-top: -$height / 2 !important;\n  margin-left: -$width / 2 !important;\n  width: $width !important;\n  min-width: unset;\n  height: $height !important;\n}\n\n// 上下居中\n@mixin setYMiddle($height) {\n  position: absolute;\n  top: 50%;\n  margin-top: -$height / 2;\n  height: $height;\n}\n\n// 左右居中\n@mixin setXMiddle($width) {\n  position: absolute;\n  left: 50%;\n  margin-left: -$width / 2;\n  width: $width;\n}\n\n// 切换动画\n@mixin transition($type) {\n  transition: .3s $type;\n}\n\n// 按钮公共样式\n@mixin btn-normal($color) {\n  @include transition(background-color);\n\n  border-color: $color;\n  border-radius: 20px;\n  width: 90px;\n  height: 40px;\n  font-size: $font-size-14;\n  text-align: center;\n  color: $color-FFFFFF;\n  background: $color;\n  line-height: 40px;\n  cursor: pointer;\n  user-select: none;\n}\n\n// 失效状态，强制使用同一种颜色\n@mixin disable($type, $color) {\n  cursor: not-allowed !important;\n\n  @if $type == \"color\" {\n    color: $color !important;\n\n    &:hover {\n      color: $color !important;\n    }\n\n    &:active {\n      color: $color !important;\n    }\n  } @else if $type == \"background-color\" {\n    background-color: $color !important;\n\n    &:hover {\n      background-color: $color !important;\n    }\n\n    &:active {\n      background-color: $color !important;\n    }\n  }\n}\n\n// 全局阴影效果\n@mixin shadow {\n  box-shadow: 0 0 10px 2px rgba(#5E5C5C, .25);\n}\n\n// 变色样式\n@mixin action-green($type) {\n  @include transition($type);\n\n  cursor: pointer;\n\n  @if $type == \"color\" {\n    &:hover {\n      color: $color-55DE99 !important;\n    }\n\n    &:active {\n      color: $color-22B76B !important;\n    }\n  } @else if $type == \"background-color\" {\n    &:hover {\n      background-color: $color-55DE99 !important;\n    }\n\n    &:active {\n      background-color: $color-22B76B !important;\n    }\n  }\n}\n\n// 清除浮动\n@mixin clearfix {\n  &::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// 旋转\n@mixin animation-rotate() {\n  animation-duration: 1s;\n  animation-name: rotate;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(1, 1, 1, 1);\n}\n\n// 文本n行溢出隐藏显示...\n@mixin ellipsis-basic($n) {\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: $n;\n  -webkit-line: $n;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n\n// 文本不换行\n@mixin no-wrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// 宽高\n@mixin wh($w: 100%, $h: 100%) {\n  width: $w;\n  height: $h;\n}\n\n// 跳转文字 有hover效果\n@mixin link($color: $text-grey-color, $hover-color: $text-grey-color) {\n  position: relative;\n  color: $color;\n  cursor: pointer;\n  user-select: none;\n\n  @content;\n\n  &:hover {\n    color: $hover-color;\n  }\n}\n\n// 跳转文字 带下划线 有hover效果\n@mixin link-underline($color: $text-grey-color, $hover-color: $text-grey-color) {\n  @include link($color, $hover-color) {\n    &:hover {\n      &::after {\n        border-bottom-color: $hover-color;\n      }\n    }\n\n    &::after {\n      position: absolute;\n      bottom: 0;\n      content: \"\";\n      left: 0;\n      border-bottom: 1px solid $color;\n      width: 100%;\n    }\n  }\n}\n\n// flex 布局\n@mixin flex($obj) {\n  display: flex;\n\n  @if map-get($obj, \"justify\") {\n    justify-content: map-get($obj, \"justify\");\n  }\n\n  @if map-get($obj, \"align\") {\n    align-items: map-get($obj, \"align\");\n  }\n}\n\n// flex 水平居中\n@mixin flex-c {\n  @include flex((justify: center));\n}\n\n// flex 垂直居中\n@mixin flex-vc {\n  @include flex((align: center));\n}\n\n// flex 水平两端对齐\n@mixin flex-sb {\n  @include flex((justify: space-between));\n}\n\n// flex 水平垂直居中\n@mixin flex-cc {\n  @include flex((justify: center, align: center));\n}\n\n// flex 水平两端对齐，垂直居中\n@mixin flex-sbc {\n  @include flex((justify: space-between, align: center));\n}","@import \"@/styles/var.scss\";\n@import \"@/styles/mixin.scss\";\n\n.skin5 {\n  height: 100%;\n  background-color: #f5f6f9;\n  line-height: normal;\n\n  .header {\n    padding: 20px 16px 10px;\n    width: 100%;\n    background-repeat: no-repeat;\n    background-size: 100% 220px;\n    background-image: url(\"~@imgs/register/new-theme/head-bg.png\");\n\n    .logoBox {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 20px;\n      display: flex;\n      align-items: center;\n\n      .logo {\n        margin-right: 10px;\n        width: 42px;\n        height: 42px;\n        background-size: 100%;\n        background-image: url(\"~@imgs/register/red-theme/logo-big.png\");\n      }\n\n      .logoBoxRight {\n        display: flex;\n        flex-direction: column;\n        .logoText {\n          width: 80px;\n          height: 21px\n        }\n        .youqianLogoText {\n          //width: 54px;\n          height: 21px\n        }\n        .youqianLogoText {\n          width: 60px;\n          height: 21px\n        }\n        .logoText2 {\n          margin-top: 4px;\n          width: 76px;\n          height: 10px\n        }\n        .logoText3 {\n          margin-top: 1px;\n          font-size: 12px;\n          color: #fff;\n          font-weight: 600;\n          transform: scale(.86) translateX(-10px);\n        }\n      }\n    }\n\n    .inputWrapper {\n      margin-top: 25px;\n      width: 343px;\n      background: linear-gradient(180deg, #FBE5D7 0%, #FFFFFF 27.54%);\n      border-radius: 8px;\n\n      .inputWrapperHead {\n        width: 100%;\n        height: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 29px;\n      }\n\n      .inputWrapperContainer {\n        margin-top: 12px;\n        padding: 24px 12px 16px;\n        .inputWrapperContainetTips {\n          font-size: 14px;\n          margin-bottom: 8px;\n          color: #262626;\n        }\n        .inputBox {\n          position: relative;\n          display: flex;\n          align-items: center;\n          .inputBoxSymbol {\n            font-size: 38px;\n            line-height: 52px;\n          }\n    \n          :global {\n            .adm-input-element {\n              font-size: 33px;\n              font-weight: 600;\n              line-height: 30px;\n              &::placeholder {\n                font-size: 22px;\n                line-height: 30px;\n                font-weight: normal;\n              }\n            }\n          }\n    \n          .text {\n            position: absolute;\n            right: 0;\n            bottom: 14px;\n            display: flex;\n            align-items: center;\n            color: #AD6800;\n            font-size: 12px;\n    \n            .clear {\n              padding-left: 9px;\n              color: #8C8C8C;\n              font-size: 16px;\n            }\n          }\n        }\n        .moneyOptions {\n          margin-top: 10px;\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          .moneyItem {\n            flex: 1;\n            height: 32px;\n            padding: 4px 8px;\n            border-radius: 6px;\n            box-sizing: border-box;\n            font-size: 14px;\n            background-color: #F3F4F6;\n            color: #8C8C8C;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            line-height: normal;\n            font-weight: 600;\n            &:nth-child(2n + 2) {\n              margin: 0 8px;\n            }\n            &.moneyItemActive {\n              color: #ff2f2f;\n              border: 1px solid #ff2f2f;\n              background-color: rgba(255, 44, 62, 0.10);\n            }\n          }\n        }\n        .line {\n          margin: 16px 0;\n          width: 100%;\n          height: 1px;\n          background-color: #EAEAEA;\n        }\n        .moneyRateTips {\n          display: flex;\n          align-items: center;\n          .moneyRateText1 {\n            padding: 3px 8px;\n            background-color: #DE9960;\n            border-radius: 4px;\n            color: #fff;\n            font-size: 12px;\n            margin-right: 8px;\n          }\n          .moneyRateText2 {\n            color: #262626;\n          }\n        }\n      }\n    }\n  }\n\n  .checkBox {\n    width: 352px;\n    margin: 11px auto 16px;\n    padding-bottom: 32px;\n    background: #fff;\n    border-radius: 8px;\n    .title {\n      width: 100%;\n      height: 38px;\n      background: linear-gradient(180deg, #FDF2E5 0%, #FBE4CE 100%);\n      border-radius: 6px 6px 0px 0px;\n      text-align: center;\n      line-height: 38px;\n      font-weight: 400;\n      font-size: 12px;\n      color: #DE9960;\n    }\n    h3 {\n      font-weight: 600;\n      font-size: 16px;\n      color: #333;\n      padding: 12px 16px 0;\n      span {\n        font-size: 12px;\n        color: #BB6C1D;\n        font-weight: normal;\n      }\n    }\n    .loanTermList {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      padding: 0 16px;\n      margin-top: 16px;\n      .loanTermItem {\n        width: 101px;\n        height: 30px;\n        background-color: #f3f4f6;\n        text-align: center;\n        border-radius: 5px;\n        box-sizing: border-box;\n        font-weight: 600;\n        p {\n          font-size: 14px;\n          color: #8C8C8C;\n          &.samllText {\n            font-size: 12px;\n          }\n        }\n        &.active {\n          background-color: #FF2C3E;\n          p {\n            font-size: 14px;\n            color: #fff;\n          }\n        }\n        &.is360Channel {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 16px;\n        }\n      }\n    }\n\n    .bottomBody {\n      margin-top: 20px;\n      box-sizing: border-box;\n      padding: 0 16px;\n      p {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        span {\n          display: inline-block;\n          color: #c16818;\n          height: 41px;\n          line-height: 41px;\n          padding: 0 16px;\n          background-repeat: no-repeat;\n          background-size: 100% 100%;\n          background-image: url(\"~@imgs/register/new-theme/bottom-body-bg.png\");\n        }\n      }\n      .phoneBox {\n        height: 46px;\n        background: #f4f5f7;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        margin: 9px auto 0;\n        padding-left: 16px;\n        .label {\n          width: 170px;\n          text-align: center;\n          font-size: 16px;\n        }\n        :global {\n          .adm-input-element {\n            font-size: 16px;\n            line-height: 30px;\n            &::placeholder {\n              font-size: 16px;\n              line-height: 30px;\n            }\n          }\n        }\n      }\n      .getCms {\n        margin-top: 12px;\n        height: 46px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: linear-gradient(180deg,#ffcfa0 1%,#e19459);\n        border-radius: 6px;\n        color: #FFFFFF;\n        font-size: 16px;\n      }\n      .agreement {\n        @include flex-cc;\n        flex-wrap: wrap;\n\n        .primary {\n          color: #DE9960;\n        }\n    \n        margin-top: 20px;\n        font-size: 12px;\n        color: #8C8C8C;\n        line-height: 18px;\n\n        &.animation {\n          position: relative;\n          animation: shake .1s;\n        }\n\n        @keyframes shake {\n          0% {\n            left: 8px;\n          }\n\n          50% {\n            left: -8px;\n          }\n    \n          100% {\n            left: 0;\n          }\n        }\n    \n        .checked {\n          margin-right: 6px;\n          border: 1px solid #D9D9D9;\n          border-radius: 100%;\n          width: 18px;\n          height: 18px;\n    \n          &.active {\n            position: relative;\n            border: none;\n            background: #DE9960;\n    \n            &::before {\n              position: absolute;\n              top: 6px;\n              left: 4px;\n              width: 10px;\n              height: 7px;\n              content: \"\";\n              background-image: url(\"~@imgs/activity/check.png\");\n              background-size: 100%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .tipBox {\n    padding-bottom: 50px;\n    .tip {\n      font-size: 12px;\n      line-height: 20px;\n      text-align: center;\n      color: $text-gray-color;\n    }\n  }\n\n  .dialogOverlay {\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(0,0,0,.7);\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    display: none;\n    &.showPopup {\n      display: block;\n    }\n    .dialogMain {\n      width: 320px;\n      height: 180px;\n      border-radius: 8px;\n      background-color: #fff;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      padding: 20px 0;\n      box-sizing: border-box;\n      .close {\n        width: 100%;\n        font-size: 20px;\n        text-align: right;\n        margin-right: 20px;\n        color: rgb(214, 217, 223);\n        padding-right: 20px;\n        box-sizing: border-box;\n      }\n      .inputBox {\n        width: 285px;\n        height: 48px;\n        border: 1px solid #e19459;\n        margin: 10px auto;\n        padding-left: 20px;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        .code {\n          width: 150px;\n          text-align: center;\n          color: #e19459;\n        }\n        :global {\n          .adm-input-element {\n            font-size: 15px;\n            line-height: 30px;\n          }\n        }\n      }\n      .limit {\n        margin: 18px auto;\n        width: 283px;\n        height: 44px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: linear-gradient(180deg,#ffcfa0 1%,#e19459);\n        border-radius: 6px;\n        color: #FFFFFF;\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n:global {\n  .adm-auto-center {\n    .adm-auto-center-content {\n      text-align: center !important;\n    }\n  }\n}\n","// 公共颜色\n$color-primary: #FF4D4F;\n\n// 主字色\n$color-black: #262626;\n$color-white: #FFFFFF;\n\n// 浅红\n$light-red: #FFF1F0;\n\n// 浅红背景\n$light-red-bg: #FFF3F4;\n\n// 背景色\n$background-color: #F6F6F6;\n\n// 线条颜色\n$line-color: #F0F0F0;\n\n// 边框颜色\n$border-color: #D9D9D9;\n\n// 文字灰色颜色\n$text-gray-color: #8C8C8C;\n\n// 渐变色\n$linear-gradient: linear-gradient(108.61deg, #FF606E 3.46%, #FF192C 97.1%);\n\n// skin12字体颜色\n$text-skin12: #684aff;\n\n// skin12渐变色\n$linear-gradient-skin12: linear-gradient(1turn, #a18eff, #684aff);\n\n// 占位符颜色\n$placeholder-color: #BFBFBF;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skin5": `skin10_skin5__9Uzq0`,
	"header": `skin10_header__Twdzs`,
	"logoBox": `skin10_logoBox__KZACk`,
	"logo": `skin10_logo__688xN`,
	"logoBoxRight": `skin10_logoBoxRight__q+4Vb`,
	"logoText": `skin10_logoText__TMWXq`,
	"youqianLogoText": `skin10_youqianLogoText__D35yW`,
	"logoText2": `skin10_logoText2__RS13Z`,
	"logoText3": `skin10_logoText3__pGpiw`,
	"inputWrapper": `skin10_inputWrapper__NzAPk`,
	"inputWrapperHead": `skin10_inputWrapperHead__ed0ZM`,
	"inputWrapperContainer": `skin10_inputWrapperContainer__nZHyW`,
	"inputWrapperContainetTips": `skin10_inputWrapperContainetTips__DE4w5`,
	"inputBox": `skin10_inputBox__5Z9CE`,
	"inputBoxSymbol": `skin10_inputBoxSymbol__2IAP-`,
	"text": `skin10_text__WOR9+`,
	"clear": `skin10_clear__BVvQu`,
	"moneyOptions": `skin10_moneyOptions__XmFfg`,
	"moneyItem": `skin10_moneyItem__lOF7o`,
	"moneyItemActive": `skin10_moneyItemActive__LcGTZ`,
	"line": `skin10_line__nuhCT`,
	"moneyRateTips": `skin10_moneyRateTips__43dl9`,
	"moneyRateText1": `skin10_moneyRateText1__uuhkT`,
	"moneyRateText2": `skin10_moneyRateText2__-VKvz`,
	"checkBox": `skin10_checkBox__9VZBv`,
	"title": `skin10_title__JUXnq`,
	"loanTermList": `skin10_loanTermList__dNIDa`,
	"loanTermItem": `skin10_loanTermItem__0PbPo`,
	"samllText": `skin10_samllText__hv5oj`,
	"active": `skin10_active__bBjBM`,
	"is360Channel": `skin10_is360Channel__0YX-k`,
	"bottomBody": `skin10_bottomBody__eTLCC`,
	"phoneBox": `skin10_phoneBox__dtfqm`,
	"label": `skin10_label__w6beC`,
	"getCms": `skin10_getCms__PRUk3`,
	"agreement": `skin10_agreement__OXp1k`,
	"primary": `skin10_primary__W7y49`,
	"animation": `skin10_animation__YcbVn`,
	"shake": `skin10_shake__j+YV6`,
	"checked": `skin10_checked__rVvLz`,
	"tipBox": `skin10_tipBox__HulL+`,
	"tip": `skin10_tip__kTfuF`,
	"dialogOverlay": `skin10_dialogOverlay__vVYos`,
	"showPopup": `skin10_showPopup__WYPn6`,
	"dialogMain": `skin10_dialogMain__QQ22O`,
	"close": `skin10_close__WBZn1`,
	"code": `skin10_code__iLStL`,
	"limit": `skin10_limit__ArtDL`,
	"rotate": `skin10_rotate__HyQR+`
};
export default ___CSS_LOADER_EXPORT___;
